export var SelectorInput = _ref => {
  var {
    borderColor,
    borderSelectedColor,
    textColor,
    textSecondaryColor
  } = _ref;
  return _ref2 => {
    var {
      focused
    } = _ref2;
    return {
      containerStyle: borderSelectedColor == null || borderColor == null ? {} : {
        // focused
        borderColor: focused ? borderSelectedColor.toString() : borderColor.toString()
      },
      labelStyle: textSecondaryColor == null ? {} : {
        color: textSecondaryColor.toString()
      },
      valueStyle: textColor == null ? {} : {
        color: textColor.toString()
      },
      linkStyle: textColor == null ? {} : {
        color: textColor.toString()
      }
    };
  };
};
//# sourceMappingURL=SelectorInput.js.map